<div class="item-container">
  <div class="item-header">
    <h5 class="text-center">{{"Agree Terms & Condition" | translate}}</h5>
    <div class="edit-icons" mat-dialog-close="">
      <i class="material-icons">close</i>
    </div>
  </div>
  <div class="item-content d-flex flex-column justify-content-center pt-3 pt-lg-4">
<p clss="mt-3">By using Univate Solutions to create and sell courses, you agree to the following terms and conditions:</p>

<ol>
    <li>
        <strong>Course Creation:</strong>
        <ul>
            <li>You, as the course creator, are responsible for the accuracy and legality of the content.</li>
            <li>Univate Solutions reserves the right to review and moderate course content to ensure compliance with our policies.</li>
        </ul>
    </li>

    <li>
        <strong>Commission Fees:</strong>
        <ul>
            <li>Univate Solutions charges a commission fee for each successful course sale.</li>
            <li>Commission rates are outlined in our pricing and fee structure, subject to periodic updates.</li>
        </ul>
    </li>

    <li>
        <strong>Payouts:</strong>
        <ul>
            <li>Earnings from course sales, minus commission fees, will be paid out according to our payout schedule.</li>
            <li>Univate Solutions reserves the right to withhold payments for any account suspected of fraudulent activity.</li>
        </ul>
    </li>

    <li>
        <strong>Intellectual Property:</strong>
        <ul>
            <li>You retain ownership of the intellectual property rights to your courses.</li>
            <li>By uploading content, you grant Univate Solutions a non-exclusive license to use, reproduce, and distribute the content for marketing and promotional purposes.</li>
        </ul>
    </li>

    <li>
        <strong>Content Standards:</strong>
        <ul>
            <li>Courses must adhere to ethical standards, avoiding discriminatory, offensive, or illegal content.</li>
            <li>Univate Solutions reserves the right to remove courses that violate these standards.</li>
        </ul>
    </li>

    <li>
        <strong>User Data:</strong>
        <ul>
            <li>Univate Solutions may collect and use user data as outlined in our Privacy Policy.</li>
            <li>You agree not to misuse any user data obtained through the platform.</li>
        </ul>
    </li>

    <li>
        <strong>Termination:</strong>
        <ul>
            <li>Univate Solutions reserves the right to terminate your account for violation of these terms.</li>
            <li>Upon termination, any outstanding commissions will be paid out, and access to course creation features will be revoked.</li>
        </ul>
    </li>

    <li>
        <strong>Updates to Terms:</strong>
        <ul>
            <li>Univate Solutions may update these terms periodically, and continued use of the platform constitutes acceptance of the updated terms.</li>
        </ul>
    </li>
</ol>

<p>By using Univate Solutions for course creation and sales, you acknowledge that you have read, understood, and agreed to these terms and conditions. Failure to comply with these terms may result in account suspension or termination.</p>

  </div>
  <div class="item-footer d-flex align-items-center justify-content-center">
    <button mat-raised-button color="warn" class="auth-form-btn  danger-btn me-3 mt-3 mt-lg-4" type="submit" mat-dialog-close >{{"BUTTON.REJECT" | translate}}</button>   
    <button mat-raised-button color="warn" class="auth-form-btn  success-btn mt-3 mt-lg-4" type="submit" (click)="onSubmit()">{{ "BUTTON.ACCEPT" | translate }}</button>
</div>
</div>
<app-loading-spinner></app-loading-spinner>